export interface AppShellLayoutOptions {
  isDesktop: boolean;
  boundedWorkspacePage: boolean;
}

/**
 * The global document deliberately stays overflow-hidden so desktop workspaces
 * can own their scroll regions. Phone and tablet pages that do not provide a
 * bounded workspace therefore need the application shell itself to be the
 * vertical scroll container.
 */
export const appShellViewportSx = ({
  isDesktop,
  boundedWorkspacePage,
}: AppShellLayoutOptions) => {
  if (boundedWorkspacePage) {
    return {
      height: isDesktop ? '100vh' : '100dvh',
      minHeight: 0,
      overflow: 'hidden',
    } as const;
  }

  if (isDesktop) {
    return {
      minHeight: '100vh',
    } as const;
  }

  return {
    height: '100dvh',
    minHeight: '100dvh',
    overflowX: 'hidden',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    touchAction: 'pan-y',
  } as const;
};
